/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthCallbackRouteImport } from './routes/authCallback'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TemplatesTemplateIdRouteImport } from './routes/templates.$templateId'
import { Route as AuthOrganizationsRouteImport } from './routes/_auth.organizations'
import { Route as AuthOrgRouteImport } from './routes/_auth._org'
import { Route as AuthOrganizationsIndexRouteImport } from './routes/_auth.organizations.index'
import { Route as AuthOrganizationsNewRouteImport } from './routes/_auth.organizations.new'
import { Route as AuthOrgUpgradeRouteImport } from './routes/_auth._org.upgrade'
import { Route as AuthOrgSettingsRouteImport } from './routes/_auth._org.settings'
import { Route as AuthOrgSettingsIndexRouteImport } from './routes/_auth._org.settings.index'
import { Route as AuthOrgAgentsIndexRouteImport } from './routes/_auth._org.agents.index'
import { Route as AuthOrgSettingsWorkspaceRouteImport } from './routes/_auth._org.settings.workspace'
import { Route as AuthOrgSettingsSecurityRouteImport } from './routes/_auth._org.settings.security'
import { Route as AuthOrgSettingsProfileRouteImport } from './routes/_auth._org.settings.profile'
import { Route as AuthOrgSettingsPlansRouteImport } from './routes/_auth._org.settings.plans'
import { Route as AuthOrgSettingsBillingRouteImport } from './routes/_auth._org.settings.billing'
import { Route as AuthOrgSettingsApiRouteImport } from './routes/_auth._org.settings.api'
import { Route as AuthOrgIntegrationsExcelRouteImport } from './routes/_auth._org.integrations.excel'
import { Route as AuthOrgAgentsNewRouteImport } from './routes/_auth._org.agents.new'
import { Route as AuthOrgAgentsAgentIdRouteImport } from './routes/_auth._org.agents.$agentId'
import { Route as AuthOrgAgentsAgentIdIndexRouteImport } from './routes/_auth._org.agents.$agentId.index'
import { Route as AuthOrgDetailsAgentsAgentIdRouteImport } from './routes/_auth._org.details.agents.$agentId'
import { Route as AuthOrgAgentsAgentIdIntegrationRouteImport } from './routes/_auth._org.agents.$agentId.integration'
import { Route as AuthOrgAgentsAgentIdInboxRouteImport } from './routes/_auth._org.agents.$agentId.inbox'
import { Route as AuthOrgAgentsAgentIdAnalyticsRouteImport } from './routes/_auth._org.agents.$agentId.analytics'
import { Route as AuthOrgDetailsAgentsAgentIdEmptyRouteImport } from './routes/_auth._org.details.agents.$agentId.empty'
import { Route as AuthOrgDetailsAgentsAgentIdRunsRunIdRouteImport } from './routes/_auth._org.details.agents.$agentId.runs.$runId'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/authCallback',
  path: '/authCallback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesTemplateIdRoute = TemplatesTemplateIdRouteImport.update({
  id: '/templates/$templateId',
  path: '/templates/$templateId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOrganizationsRoute = AuthOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrgRoute = AuthOrgRouteImport.update({
  id: '/_org',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrganizationsIndexRoute = AuthOrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrganizationsRoute,
} as any)
const AuthOrganizationsNewRoute = AuthOrganizationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthOrganizationsRoute,
} as any)
const AuthOrgUpgradeRoute = AuthOrgUpgradeRouteImport.update({
  id: '/upgrade',
  path: '/upgrade',
  getParentRoute: () => AuthOrgRoute,
} as any)
const AuthOrgSettingsRoute = AuthOrgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthOrgRoute,
} as any)
const AuthOrgSettingsIndexRoute = AuthOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgSettingsRoute,
} as any)
const AuthOrgAgentsIndexRoute = AuthOrgAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AuthOrgRoute,
} as any)
const AuthOrgSettingsWorkspaceRoute =
  AuthOrgSettingsWorkspaceRouteImport.update({
    id: '/workspace',
    path: '/workspace',
    getParentRoute: () => AuthOrgSettingsRoute,
  } as any)
const AuthOrgSettingsSecurityRoute = AuthOrgSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthOrgSettingsRoute,
} as any)
const AuthOrgSettingsProfileRoute = AuthOrgSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthOrgSettingsRoute,
} as any)
const AuthOrgSettingsPlansRoute = AuthOrgSettingsPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AuthOrgSettingsRoute,
} as any)
const AuthOrgSettingsBillingRoute = AuthOrgSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthOrgSettingsRoute,
} as any)
const AuthOrgSettingsApiRoute = AuthOrgSettingsApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => AuthOrgSettingsRoute,
} as any)
const AuthOrgIntegrationsExcelRoute =
  AuthOrgIntegrationsExcelRouteImport.update({
    id: '/integrations/excel',
    path: '/integrations/excel',
    getParentRoute: () => AuthOrgRoute,
  } as any)
const AuthOrgAgentsNewRoute = AuthOrgAgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => AuthOrgRoute,
} as any)
const AuthOrgAgentsAgentIdRoute = AuthOrgAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => AuthOrgRoute,
} as any)
const AuthOrgAgentsAgentIdIndexRoute =
  AuthOrgAgentsAgentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgAgentsAgentIdRoute,
  } as any)
const AuthOrgDetailsAgentsAgentIdRoute =
  AuthOrgDetailsAgentsAgentIdRouteImport.update({
    id: '/details/agents/$agentId',
    path: '/details/agents/$agentId',
    getParentRoute: () => AuthOrgRoute,
  } as any)
const AuthOrgAgentsAgentIdIntegrationRoute =
  AuthOrgAgentsAgentIdIntegrationRouteImport.update({
    id: '/integration',
    path: '/integration',
    getParentRoute: () => AuthOrgAgentsAgentIdRoute,
  } as any)
const AuthOrgAgentsAgentIdInboxRoute =
  AuthOrgAgentsAgentIdInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => AuthOrgAgentsAgentIdRoute,
  } as any)
const AuthOrgAgentsAgentIdAnalyticsRoute =
  AuthOrgAgentsAgentIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthOrgAgentsAgentIdRoute,
  } as any)
const AuthOrgDetailsAgentsAgentIdEmptyRoute =
  AuthOrgDetailsAgentsAgentIdEmptyRouteImport.update({
    id: '/empty',
    path: '/empty',
    getParentRoute: () => AuthOrgDetailsAgentsAgentIdRoute,
  } as any)
const AuthOrgDetailsAgentsAgentIdRunsRunIdRoute =
  AuthOrgDetailsAgentsAgentIdRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthOrgDetailsAgentsAgentIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/authCallback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/organizations': typeof AuthOrganizationsRouteWithChildren
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/settings': typeof AuthOrgSettingsRouteWithChildren
  '/upgrade': typeof AuthOrgUpgradeRoute
  '/organizations/new': typeof AuthOrganizationsNewRoute
  '/organizations/': typeof AuthOrganizationsIndexRoute
  '/agents/$agentId': typeof AuthOrgAgentsAgentIdRouteWithChildren
  '/agents/new': typeof AuthOrgAgentsNewRoute
  '/integrations/excel': typeof AuthOrgIntegrationsExcelRoute
  '/settings/api': typeof AuthOrgSettingsApiRoute
  '/settings/billing': typeof AuthOrgSettingsBillingRoute
  '/settings/plans': typeof AuthOrgSettingsPlansRoute
  '/settings/profile': typeof AuthOrgSettingsProfileRoute
  '/settings/security': typeof AuthOrgSettingsSecurityRoute
  '/settings/workspace': typeof AuthOrgSettingsWorkspaceRoute
  '/agents/': typeof AuthOrgAgentsIndexRoute
  '/settings/': typeof AuthOrgSettingsIndexRoute
  '/agents/$agentId/analytics': typeof AuthOrgAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/inbox': typeof AuthOrgAgentsAgentIdInboxRoute
  '/agents/$agentId/integration': typeof AuthOrgAgentsAgentIdIntegrationRoute
  '/details/agents/$agentId': typeof AuthOrgDetailsAgentsAgentIdRouteWithChildren
  '/agents/$agentId/': typeof AuthOrgAgentsAgentIdIndexRoute
  '/details/agents/$agentId/empty': typeof AuthOrgDetailsAgentsAgentIdEmptyRoute
  '/details/agents/$agentId/runs/$runId': typeof AuthOrgDetailsAgentsAgentIdRunsRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/authCallback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/upgrade': typeof AuthOrgUpgradeRoute
  '/organizations/new': typeof AuthOrganizationsNewRoute
  '/organizations': typeof AuthOrganizationsIndexRoute
  '/agents/new': typeof AuthOrgAgentsNewRoute
  '/integrations/excel': typeof AuthOrgIntegrationsExcelRoute
  '/settings/api': typeof AuthOrgSettingsApiRoute
  '/settings/billing': typeof AuthOrgSettingsBillingRoute
  '/settings/plans': typeof AuthOrgSettingsPlansRoute
  '/settings/profile': typeof AuthOrgSettingsProfileRoute
  '/settings/security': typeof AuthOrgSettingsSecurityRoute
  '/settings/workspace': typeof AuthOrgSettingsWorkspaceRoute
  '/agents': typeof AuthOrgAgentsIndexRoute
  '/settings': typeof AuthOrgSettingsIndexRoute
  '/agents/$agentId/analytics': typeof AuthOrgAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/inbox': typeof AuthOrgAgentsAgentIdInboxRoute
  '/agents/$agentId/integration': typeof AuthOrgAgentsAgentIdIntegrationRoute
  '/details/agents/$agentId': typeof AuthOrgDetailsAgentsAgentIdRouteWithChildren
  '/agents/$agentId': typeof AuthOrgAgentsAgentIdIndexRoute
  '/details/agents/$agentId/empty': typeof AuthOrgDetailsAgentsAgentIdEmptyRoute
  '/details/agents/$agentId/runs/$runId': typeof AuthOrgDetailsAgentsAgentIdRunsRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/authCallback': typeof AuthCallbackRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_auth/_org': typeof AuthOrgRouteWithChildren
  '/_auth/organizations': typeof AuthOrganizationsRouteWithChildren
  '/templates/$templateId': typeof TemplatesTemplateIdRoute
  '/_auth/_org/settings': typeof AuthOrgSettingsRouteWithChildren
  '/_auth/_org/upgrade': typeof AuthOrgUpgradeRoute
  '/_auth/organizations/new': typeof AuthOrganizationsNewRoute
  '/_auth/organizations/': typeof AuthOrganizationsIndexRoute
  '/_auth/_org/agents/$agentId': typeof AuthOrgAgentsAgentIdRouteWithChildren
  '/_auth/_org/agents/new': typeof AuthOrgAgentsNewRoute
  '/_auth/_org/integrations/excel': typeof AuthOrgIntegrationsExcelRoute
  '/_auth/_org/settings/api': typeof AuthOrgSettingsApiRoute
  '/_auth/_org/settings/billing': typeof AuthOrgSettingsBillingRoute
  '/_auth/_org/settings/plans': typeof AuthOrgSettingsPlansRoute
  '/_auth/_org/settings/profile': typeof AuthOrgSettingsProfileRoute
  '/_auth/_org/settings/security': typeof AuthOrgSettingsSecurityRoute
  '/_auth/_org/settings/workspace': typeof AuthOrgSettingsWorkspaceRoute
  '/_auth/_org/agents/': typeof AuthOrgAgentsIndexRoute
  '/_auth/_org/settings/': typeof AuthOrgSettingsIndexRoute
  '/_auth/_org/agents/$agentId/analytics': typeof AuthOrgAgentsAgentIdAnalyticsRoute
  '/_auth/_org/agents/$agentId/inbox': typeof AuthOrgAgentsAgentIdInboxRoute
  '/_auth/_org/agents/$agentId/integration': typeof AuthOrgAgentsAgentIdIntegrationRoute
  '/_auth/_org/details/agents/$agentId': typeof AuthOrgDetailsAgentsAgentIdRouteWithChildren
  '/_auth/_org/agents/$agentId/': typeof AuthOrgAgentsAgentIdIndexRoute
  '/_auth/_org/details/agents/$agentId/empty': typeof AuthOrgDetailsAgentsAgentIdEmptyRoute
  '/_auth/_org/details/agents/$agentId/runs/$runId': typeof AuthOrgDetailsAgentsAgentIdRunsRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/authCallback'
    | '/login'
    | '/logout'
    | '/organizations'
    | '/templates/$templateId'
    | '/settings'
    | '/upgrade'
    | '/organizations/new'
    | '/organizations/'
    | '/agents/$agentId'
    | '/agents/new'
    | '/integrations/excel'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/plans'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/workspace'
    | '/agents/'
    | '/settings/'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/inbox'
    | '/agents/$agentId/integration'
    | '/details/agents/$agentId'
    | '/agents/$agentId/'
    | '/details/agents/$agentId/empty'
    | '/details/agents/$agentId/runs/$runId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/authCallback'
    | '/login'
    | '/logout'
    | '/templates/$templateId'
    | '/upgrade'
    | '/organizations/new'
    | '/organizations'
    | '/agents/new'
    | '/integrations/excel'
    | '/settings/api'
    | '/settings/billing'
    | '/settings/plans'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/workspace'
    | '/agents'
    | '/settings'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/inbox'
    | '/agents/$agentId/integration'
    | '/details/agents/$agentId'
    | '/agents/$agentId'
    | '/details/agents/$agentId/empty'
    | '/details/agents/$agentId/runs/$runId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/authCallback'
    | '/login'
    | '/logout'
    | '/_auth/_org'
    | '/_auth/organizations'
    | '/templates/$templateId'
    | '/_auth/_org/settings'
    | '/_auth/_org/upgrade'
    | '/_auth/organizations/new'
    | '/_auth/organizations/'
    | '/_auth/_org/agents/$agentId'
    | '/_auth/_org/agents/new'
    | '/_auth/_org/integrations/excel'
    | '/_auth/_org/settings/api'
    | '/_auth/_org/settings/billing'
    | '/_auth/_org/settings/plans'
    | '/_auth/_org/settings/profile'
    | '/_auth/_org/settings/security'
    | '/_auth/_org/settings/workspace'
    | '/_auth/_org/agents/'
    | '/_auth/_org/settings/'
    | '/_auth/_org/agents/$agentId/analytics'
    | '/_auth/_org/agents/$agentId/inbox'
    | '/_auth/_org/agents/$agentId/integration'
    | '/_auth/_org/details/agents/$agentId'
    | '/_auth/_org/agents/$agentId/'
    | '/_auth/_org/details/agents/$agentId/empty'
    | '/_auth/_org/details/agents/$agentId/runs/$runId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  TemplatesTemplateIdRoute: typeof TemplatesTemplateIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/authCallback': {
      id: '/authCallback'
      path: '/authCallback'
      fullPath: '/authCallback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/$templateId': {
      id: '/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof TemplatesTemplateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/organizations': {
      id: '/_auth/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthOrganizationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_org': {
      id: '/_auth/_org'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthOrgRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/organizations/': {
      id: '/_auth/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthOrganizationsIndexRouteImport
      parentRoute: typeof AuthOrganizationsRoute
    }
    '/_auth/organizations/new': {
      id: '/_auth/organizations/new'
      path: '/new'
      fullPath: '/organizations/new'
      preLoaderRoute: typeof AuthOrganizationsNewRouteImport
      parentRoute: typeof AuthOrganizationsRoute
    }
    '/_auth/_org/upgrade': {
      id: '/_auth/_org/upgrade'
      path: '/upgrade'
      fullPath: '/upgrade'
      preLoaderRoute: typeof AuthOrgUpgradeRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/settings': {
      id: '/_auth/_org/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthOrgSettingsRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/settings/': {
      id: '/_auth/_org/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthOrgSettingsIndexRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/agents/': {
      id: '/_auth/_org/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthOrgAgentsIndexRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/settings/workspace': {
      id: '/_auth/_org/settings/workspace'
      path: '/workspace'
      fullPath: '/settings/workspace'
      preLoaderRoute: typeof AuthOrgSettingsWorkspaceRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/settings/security': {
      id: '/_auth/_org/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthOrgSettingsSecurityRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/settings/profile': {
      id: '/_auth/_org/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthOrgSettingsProfileRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/settings/plans': {
      id: '/_auth/_org/settings/plans'
      path: '/plans'
      fullPath: '/settings/plans'
      preLoaderRoute: typeof AuthOrgSettingsPlansRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/settings/billing': {
      id: '/_auth/_org/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthOrgSettingsBillingRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/settings/api': {
      id: '/_auth/_org/settings/api'
      path: '/api'
      fullPath: '/settings/api'
      preLoaderRoute: typeof AuthOrgSettingsApiRouteImport
      parentRoute: typeof AuthOrgSettingsRoute
    }
    '/_auth/_org/integrations/excel': {
      id: '/_auth/_org/integrations/excel'
      path: '/integrations/excel'
      fullPath: '/integrations/excel'
      preLoaderRoute: typeof AuthOrgIntegrationsExcelRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/agents/new': {
      id: '/_auth/_org/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AuthOrgAgentsNewRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/agents/$agentId': {
      id: '/_auth/_org/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthOrgAgentsAgentIdRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/agents/$agentId/': {
      id: '/_auth/_org/agents/$agentId/'
      path: '/'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AuthOrgAgentsAgentIdIndexRouteImport
      parentRoute: typeof AuthOrgAgentsAgentIdRoute
    }
    '/_auth/_org/details/agents/$agentId': {
      id: '/_auth/_org/details/agents/$agentId'
      path: '/details/agents/$agentId'
      fullPath: '/details/agents/$agentId'
      preLoaderRoute: typeof AuthOrgDetailsAgentsAgentIdRouteImport
      parentRoute: typeof AuthOrgRoute
    }
    '/_auth/_org/agents/$agentId/integration': {
      id: '/_auth/_org/agents/$agentId/integration'
      path: '/integration'
      fullPath: '/agents/$agentId/integration'
      preLoaderRoute: typeof AuthOrgAgentsAgentIdIntegrationRouteImport
      parentRoute: typeof AuthOrgAgentsAgentIdRoute
    }
    '/_auth/_org/agents/$agentId/inbox': {
      id: '/_auth/_org/agents/$agentId/inbox'
      path: '/inbox'
      fullPath: '/agents/$agentId/inbox'
      preLoaderRoute: typeof AuthOrgAgentsAgentIdInboxRouteImport
      parentRoute: typeof AuthOrgAgentsAgentIdRoute
    }
    '/_auth/_org/agents/$agentId/analytics': {
      id: '/_auth/_org/agents/$agentId/analytics'
      path: '/analytics'
      fullPath: '/agents/$agentId/analytics'
      preLoaderRoute: typeof AuthOrgAgentsAgentIdAnalyticsRouteImport
      parentRoute: typeof AuthOrgAgentsAgentIdRoute
    }
    '/_auth/_org/details/agents/$agentId/empty': {
      id: '/_auth/_org/details/agents/$agentId/empty'
      path: '/empty'
      fullPath: '/details/agents/$agentId/empty'
      preLoaderRoute: typeof AuthOrgDetailsAgentsAgentIdEmptyRouteImport
      parentRoute: typeof AuthOrgDetailsAgentsAgentIdRoute
    }
    '/_auth/_org/details/agents/$agentId/runs/$runId': {
      id: '/_auth/_org/details/agents/$agentId/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/details/agents/$agentId/runs/$runId'
      preLoaderRoute: typeof AuthOrgDetailsAgentsAgentIdRunsRunIdRouteImport
      parentRoute: typeof AuthOrgDetailsAgentsAgentIdRoute
    }
  }
}

interface AuthOrgSettingsRouteChildren {
  AuthOrgSettingsApiRoute: typeof AuthOrgSettingsApiRoute
  AuthOrgSettingsBillingRoute: typeof AuthOrgSettingsBillingRoute
  AuthOrgSettingsPlansRoute: typeof AuthOrgSettingsPlansRoute
  AuthOrgSettingsProfileRoute: typeof AuthOrgSettingsProfileRoute
  AuthOrgSettingsSecurityRoute: typeof AuthOrgSettingsSecurityRoute
  AuthOrgSettingsWorkspaceRoute: typeof AuthOrgSettingsWorkspaceRoute
  AuthOrgSettingsIndexRoute: typeof AuthOrgSettingsIndexRoute
}

const AuthOrgSettingsRouteChildren: AuthOrgSettingsRouteChildren = {
  AuthOrgSettingsApiRoute: AuthOrgSettingsApiRoute,
  AuthOrgSettingsBillingRoute: AuthOrgSettingsBillingRoute,
  AuthOrgSettingsPlansRoute: AuthOrgSettingsPlansRoute,
  AuthOrgSettingsProfileRoute: AuthOrgSettingsProfileRoute,
  AuthOrgSettingsSecurityRoute: AuthOrgSettingsSecurityRoute,
  AuthOrgSettingsWorkspaceRoute: AuthOrgSettingsWorkspaceRoute,
  AuthOrgSettingsIndexRoute: AuthOrgSettingsIndexRoute,
}

const AuthOrgSettingsRouteWithChildren = AuthOrgSettingsRoute._addFileChildren(
  AuthOrgSettingsRouteChildren,
)

interface AuthOrgAgentsAgentIdRouteChildren {
  AuthOrgAgentsAgentIdAnalyticsRoute: typeof AuthOrgAgentsAgentIdAnalyticsRoute
  AuthOrgAgentsAgentIdInboxRoute: typeof AuthOrgAgentsAgentIdInboxRoute
  AuthOrgAgentsAgentIdIntegrationRoute: typeof AuthOrgAgentsAgentIdIntegrationRoute
  AuthOrgAgentsAgentIdIndexRoute: typeof AuthOrgAgentsAgentIdIndexRoute
}

const AuthOrgAgentsAgentIdRouteChildren: AuthOrgAgentsAgentIdRouteChildren = {
  AuthOrgAgentsAgentIdAnalyticsRoute: AuthOrgAgentsAgentIdAnalyticsRoute,
  AuthOrgAgentsAgentIdInboxRoute: AuthOrgAgentsAgentIdInboxRoute,
  AuthOrgAgentsAgentIdIntegrationRoute: AuthOrgAgentsAgentIdIntegrationRoute,
  AuthOrgAgentsAgentIdIndexRoute: AuthOrgAgentsAgentIdIndexRoute,
}

const AuthOrgAgentsAgentIdRouteWithChildren =
  AuthOrgAgentsAgentIdRoute._addFileChildren(AuthOrgAgentsAgentIdRouteChildren)

interface AuthOrgDetailsAgentsAgentIdRouteChildren {
  AuthOrgDetailsAgentsAgentIdEmptyRoute: typeof AuthOrgDetailsAgentsAgentIdEmptyRoute
  AuthOrgDetailsAgentsAgentIdRunsRunIdRoute: typeof AuthOrgDetailsAgentsAgentIdRunsRunIdRoute
}

const AuthOrgDetailsAgentsAgentIdRouteChildren: AuthOrgDetailsAgentsAgentIdRouteChildren =
  {
    AuthOrgDetailsAgentsAgentIdEmptyRoute:
      AuthOrgDetailsAgentsAgentIdEmptyRoute,
    AuthOrgDetailsAgentsAgentIdRunsRunIdRoute:
      AuthOrgDetailsAgentsAgentIdRunsRunIdRoute,
  }

const AuthOrgDetailsAgentsAgentIdRouteWithChildren =
  AuthOrgDetailsAgentsAgentIdRoute._addFileChildren(
    AuthOrgDetailsAgentsAgentIdRouteChildren,
  )

interface AuthOrgRouteChildren {
  AuthOrgSettingsRoute: typeof AuthOrgSettingsRouteWithChildren
  AuthOrgUpgradeRoute: typeof AuthOrgUpgradeRoute
  AuthOrgAgentsAgentIdRoute: typeof AuthOrgAgentsAgentIdRouteWithChildren
  AuthOrgAgentsNewRoute: typeof AuthOrgAgentsNewRoute
  AuthOrgIntegrationsExcelRoute: typeof AuthOrgIntegrationsExcelRoute
  AuthOrgAgentsIndexRoute: typeof AuthOrgAgentsIndexRoute
  AuthOrgDetailsAgentsAgentIdRoute: typeof AuthOrgDetailsAgentsAgentIdRouteWithChildren
}

const AuthOrgRouteChildren: AuthOrgRouteChildren = {
  AuthOrgSettingsRoute: AuthOrgSettingsRouteWithChildren,
  AuthOrgUpgradeRoute: AuthOrgUpgradeRoute,
  AuthOrgAgentsAgentIdRoute: AuthOrgAgentsAgentIdRouteWithChildren,
  AuthOrgAgentsNewRoute: AuthOrgAgentsNewRoute,
  AuthOrgIntegrationsExcelRoute: AuthOrgIntegrationsExcelRoute,
  AuthOrgAgentsIndexRoute: AuthOrgAgentsIndexRoute,
  AuthOrgDetailsAgentsAgentIdRoute:
    AuthOrgDetailsAgentsAgentIdRouteWithChildren,
}

const AuthOrgRouteWithChildren =
  AuthOrgRoute._addFileChildren(AuthOrgRouteChildren)

interface AuthOrganizationsRouteChildren {
  AuthOrganizationsNewRoute: typeof AuthOrganizationsNewRoute
  AuthOrganizationsIndexRoute: typeof AuthOrganizationsIndexRoute
}

const AuthOrganizationsRouteChildren: AuthOrganizationsRouteChildren = {
  AuthOrganizationsNewRoute: AuthOrganizationsNewRoute,
  AuthOrganizationsIndexRoute: AuthOrganizationsIndexRoute,
}

const AuthOrganizationsRouteWithChildren =
  AuthOrganizationsRoute._addFileChildren(AuthOrganizationsRouteChildren)

interface AuthRouteChildren {
  AuthOrgRoute: typeof AuthOrgRouteWithChildren
  AuthOrganizationsRoute: typeof AuthOrganizationsRouteWithChildren
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthOrgRoute: AuthOrgRouteWithChildren,
  AuthOrganizationsRoute: AuthOrganizationsRouteWithChildren,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  TemplatesTemplateIdRoute: TemplatesTemplateIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
